import { ChevronLeft } from 'lucide-react'
import type { ReactNode } from 'react'
import {
  matchRoutes,
  NavLink,
  useLocation,
  useNavigate,
} from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface HeaderItemProps {
  title?: string
  path: string
}

interface Props {
  title: string
  items?: Array<HeaderItemProps>
  canReturn?: boolean
  matchPaths?: boolean
  // À direita do título (por exemplo, um selo de situação).
  endContent?: ReactNode
}

function HeaderItem(props: HeaderItemProps) {
  return (
    <NavLink to={props.path}>
      {({ isActive }) => (
        <div
          className={cn(
            'border-b-2 border-transparent p-2 text-sm',
            isActive && 'border-primary text-primary',
          )}
        >
          {props.title}
        </div>
      )}
    </NavLink>
  )
}

export function PageHeader(props: Props) {
  const location = useLocation()
  const match = matchRoutes(
    (props.items ?? []).map((ea) => ({ path: ea.path })),
    location,
  )

  const navigate = useNavigate()

  if (props.matchPaths && !match) return null

  return (
    <div className="z-10 border-b border-muted bg-muted px-8">
      <div className="flex items-center gap-0 py-4">
        {props.canReturn && (
          <Button
            variant="ghost"
            size="icon"
            className="mr-2"
            aria-label="Voltar"
            onClick={() => navigate('../')}
          >
            <ChevronLeft className="h-4 w-4" strokeWidth={1} />
          </Button>
        )}

        <h1 className="text-3xl font-light">{props.title}</h1>

        {props.endContent && <div className="ml-4">{props.endContent}</div>}
      </div>

      <div className="flex items-center gap-4">
        {(props.items ?? [])
          .filter((ea) => ea?.title !== undefined)
          .map((ea) => {
            return <HeaderItem key={ea.path} {...ea} />
          })}
      </div>
    </div>
  )
}
